import { useMutation } from "@tanstack/react-query";
import { api, endpoints, useAuthStore } from "@vixi/api";
import { RegisterRequest } from "@vixi/types";

export const useSignup = () => {
  const { setRegisteringUser } = useAuthStore();

  const mutationFn = async (data: RegisterRequest) => {
    await api.post(endpoints.register, data);
    setRegisteringUser({ email: data.email });
  };

  const mutation = useMutation({
    mutationKey: ["signup"],
    mutationFn,
  });

  return mutation;
};
